import { defineComponent as _defineComponent } from 'vue'
import { ref, computed, onMounted, watch } from 'vue'
    import { useId, useRouter } from '@common/composables'
    import { useAdminDatasetsDetailsPage } from '@Integrations/Datasets/pages-core'

    
export default /*#__PURE__*/_defineComponent({
  __name: 'AdminDatasetDetailsPage',
  setup(__props) {

    const router = useRouter()
    const id = useId()

    const {
        useCurrentUserQuery,
        useDatasetDetailsQuery,
        useDatasetChangeLogQueryV1,
        useClearDatasetItemsCommand,
        useDeleteDatasetCommand,
        usePermanentDeleteDatasetCommand,
    } = useAdminDatasetsDetailsPage()

    const showApi = ref(false)

    const { modelCurrentUserQueryV1, runCurrentUserQueryV1 } = useCurrentUserQuery()
    const userId = computed(() => modelCurrentUserQueryV1.value?.UserId)

    const { modelDatasetDetailsQueryV1, runDatasetDetailsQueryV1 } = useDatasetDetailsQuery(id)
    const tid = computed(() => modelDatasetDetailsQueryV1.value?.OrganizationUnitId)
    const name = computed(() => modelDatasetDetailsQueryV1.value?.Name)
    const data = computed(() => modelDatasetDetailsQueryV1.value?.Data)
    const isDeleted = computed(() => modelDatasetDetailsQueryV1.value?.IsDeleted)

    const { modelDatasetChangeLogQueryV1, runDatasetChangeLogQueryV1 } = useDatasetChangeLogQueryV1(id)
    const changes = computed(() => modelDatasetChangeLogQueryV1.value?.Changes || [])
    const changesReversed = computed(() => changes.value.reverse())

    const { invokeClearDatasetItemsCommandV1, succeedClearDatasetItemsCommandV1 } = useClearDatasetItemsCommand(id, tid, userId)

    const { invokeDeleteDatasetCommandV1, succeedDeleteDatasetCommandV1 } = useDeleteDatasetCommand(id, tid, userId)
    const { invokePermanentDeleteDatasetCommandV1, succeedPermanentDeleteDatasetCommandV1 } = usePermanentDeleteDatasetCommand(id)

    function handleClearDatasetItemsCommandV1() {
        if (confirm('Do you want to clear all dataset items permenently?')) {
            invokeClearDatasetItemsCommandV1()
        }
    }

    function handleDeleteDatasetCommandV1() {
        if (confirm(`Do you really want to delete dataset ${name.value}?`)) invokeDeleteDatasetCommandV1()
    }

    function handlePermanentDeleteDatasetCommandV1() {
        if (confirm(`Do you really want to PERMANENTLY delete dataset ${name.value}?`)) invokePermanentDeleteDatasetCommandV1()
    }

    onMounted(() => {
        runCurrentUserQueryV1()
        runDatasetDetailsQueryV1()
        runDatasetChangeLogQueryV1()
    })

    watch(name, () => document.title = name.value)

    watch([succeedClearDatasetItemsCommandV1, succeedDeleteDatasetCommandV1], () => runDatasetDetailsQueryV1())

    watch(succeedPermanentDeleteDatasetCommandV1, (val) => val ? router.push(`/admin/integrations/datasets/manage/${tid.value}`) : null)

return { __sfc: true,router, id, useCurrentUserQuery, useDatasetDetailsQuery, useDatasetChangeLogQueryV1, useClearDatasetItemsCommand, useDeleteDatasetCommand, usePermanentDeleteDatasetCommand, showApi, modelCurrentUserQueryV1, runCurrentUserQueryV1, userId, modelDatasetDetailsQueryV1, runDatasetDetailsQueryV1, tid, name, data, isDeleted, modelDatasetChangeLogQueryV1, runDatasetChangeLogQueryV1, changes, changesReversed, invokeClearDatasetItemsCommandV1, succeedClearDatasetItemsCommandV1, invokeDeleteDatasetCommandV1, succeedDeleteDatasetCommandV1, invokePermanentDeleteDatasetCommandV1, succeedPermanentDeleteDatasetCommandV1, handleClearDatasetItemsCommandV1, handleDeleteDatasetCommandV1, handlePermanentDeleteDatasetCommandV1 }
}

})